import { Md5 } from 'md5-typescript';
import { elementsList, eleProperty, metalElements } from '@/config/const'

//替换分子式字符串
export const replaceFormulaStr = (str: any) => {
  str = String(str);
  str = str.replace(/0/g, "₀");
  str = str.replace(/1/g, "₁");
  str = str.replace(/2/g, "₂");
  str = str.replace(/3/g, "₃");
  str = str.replace(/4/g, "₄");
  str = str.replace(/5/g, "₅");
  str = str.replace(/6/g, "₆");
  str = str.replace(/7/g, "₇");
  str = str.replace(/8/g, "₈");
  str = str.replace(/9/g, "₉");
  return str;
}

export const rebuildFormula = (f: string) => {
  if (f && f.includes('-')) {
    const arr = f.split('-');
    return replaceFormulaStr(arr[0]) + '-' + arr[1];
  } else {
    return replaceFormulaStr(f)
  }
}

export const getshowNumber = (num: number, length: number = 3) => {
  return Number(num.toFixed(length));
};

//根据摩尔气相分率判断相态
export const judgePase = (data: any) => {
  return data >= 0.99 ? '汽相' : data <= 0.01 ? '液相' : '汽液混合';
};

export const replaceStr = (str: any) => {
  return str.replace(/\r?\n|\r/g, "<br />");
};
// 深拷贝
export const deepClone = (obj: any) => {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }
  let result: any = Array.isArray(obj) ? [] : {};
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = deepClone(obj[key]);
    }
  }
  return result;
}

export const randomId = () => {
  // 随机ID
  // return (Math.random() * 10000000).toString(16).substr(0, 4) + (new Date()).getTime() + Math.random().toString();
  return Md5.init((Math.random() * 10000000).toString(16).substr(0, 4) + (new Date()).getTime() + Math.random().toString());
}

export const radomGetArrOneData = (arr: any) => {
  // 从数组中随机取一个元素
  const index = radomInt(0, arr.length);
  // console.log(index);
  return arr[index];
}

//随机从数组中去随机或定长的数组
export const radomArr = (oarr: any, length: any = 3) => {
  // const count = radomInt(2, 4);
  const arr = deepClone(oarr);
  const list: any = []
  for (let n = 0; n < length; n++) {
    const r = radomInt(0, arr.length);
    const v = arr[r];
    list.push(v);
    arr.splice(r, 1)
  }
  return list;
}

export const shuffle = (arr: string[] | number[]) => {
  // 随机打乱数组
  for (let i = 0; i < arr.length; i++) {
    const iRand = parseInt(arr.length * Math.random() + '');
    const temp = arr[i];
    arr[i] = arr[iRand];
    arr[iRand] = temp;
  }
  return arr;
}

export const radomInt = (m: number, n: number) => {
  // 生成一定范围内的随机整数
  const num = Math.floor(Math.random() * (m - n) + n) + '';
  return parseInt(num);
};

export const radomFloat = (m: number, n: number) => {
  // 生成一定范围内的随机两位小数
  let num = Math.floor(Math.random() * (m - n) + n);
  num = parseInt(num + '') + parseFloat(Math.random() + '');
  num = Math.round(num * 100) / 100;
  return num;
};


export const radomDataArr = (max: number, min: number, arrLen: number) => {
  // 随机生成定长整数数组
  let arr = [];
  for (let n = 1; n <= arrLen; n++) {
    arr.push(radomInt(max, min));
  }
  return arr;
};
export const radomFloatDataArr = (max: number, min: number, arrLen: number) => {
  // 随机生成定长浮点数数组
  let arr = [];
  for (let n = 1; n <= arrLen; n++) {
    arr.push(radomFloat(max, min));
  }
  return arr;
};

export const getTwoNumber = (arr: number) => {
  // 保留两位小数
  return Math.round(arr * 100) / 100;
}

export const getQueryString: any = (name: any) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
}


// 分子文件命名
const getName = (info: any) => {
  let f: any = '';

  if (info.hasOwnProperty('C')) {
    f += `C${replaceFormulaStr(info['C'].total)}`;
    delete info['C'];
  }
  if (info.hasOwnProperty('H')) {
    f += `H${replaceFormulaStr(info['H'].total)}`;
    delete info['H'];
  }

  Object.keys(info).map((key: any) => {
    f += `${key}${info[key].total === 1 ? '' : replaceFormulaStr(info[key].total)}`
  })
  return f
}

export const getJobName = (id: any) => {
  const arr = id.split('-');
  return '计算任务-' + arr[0];
}

// 分子结构信息
export const getallAtomsCate: any = (atomsInfos: any) => {
  let d: any = {};
  if (atomsInfos.length) {
    atomsInfos.map((item: any) => {
      if (!d.hasOwnProperty(item.atom)) {
        // const s:any={
        //   name:elementsList[item.atom].cname
        // };
        d[item.atom] = {};
        d[item.atom].name = elementsList[item.atom].cname;
        d[item.atom].symbol = item.atom;
        d[item.atom].total = 1;
      } else {
        d[item.atom].total = d[item.atom].total + 1;
      }
    });
    return {
      infos: { ...d },
      total: atomsInfos.length,
      name: getName(d)
    };
  } else {
    return null;
  }
};


//数组对象并集 key-比较字段
export const arrObjUnion = (arr1: any, arr2: any, key = 'id') => {
  const arr3 = arr1.concat(arr2);
  let result: any = [];
  let obj: any = [];
  result = arr3.reduce((prev: any, cur: any) => {
    obj[cur[key]] ? '' : obj[cur[key]] = true && prev.push(cur);
    return prev;
  }, []);
  return result
}

//简单数组数组并集
export const arrUnion = (arr1: any, arr2: any) => {
  return arr1.concat(arr2.filter((v: any) => !arr1.includes(v)))
}

//数组对象取交集
export const arrObjIntersection = (arr1: any, arr2: any) => {
  return arr2.filter((v: any) => {
    return arr1.some((n: any) => JSON.stringify(n) === JSON.stringify(v))
  })
}



//单个单元操作入口流股数据集合
export const getInEdges = (nodeID: any, edges: any) => {
  const froms: any = [];
  edges.map((e: any) => {
    if (nodeID === e.target) {
      froms.push(e);
    }
  });
  return froms;
};

//单个单元操作出口流股数据集合
export const getOutEdges = (nodeID: any, edges: any) => {
  const outs: any = [];
  edges.map((e: any) => {
    if (nodeID === e.source) {
      outs.push(e);
    }
  });
  return outs;
};

//各个单元操作出口流股
export const getAllOutEdges = (nodes: any, edges: any) => {
  let blockToStream: any = {}
  nodes.map((node: any) => {
    if (node.data.details.type === 'node') {
      const outs = getOutEdges(node.id, edges).map((e: any) => e.data.text);
      blockToStream[node.data.label] = outs
    }
  })
  return blockToStream
}

//单个流股流向的单元操作集合
export const getTargetNodes = (edge: any, nodes: any) => {
  const targetNodes: any = [];
  nodes.map((node: any) => {
    if (node.data.details.type === 'node') {
      if (edge.target === node.id) {
        targetNodes.push(node)
      }
    }
  })
  return targetNodes;
}

//各个流股流向的单元操作集合
export const getAllEdgeTargetNodes = (edges: any, nodes: any) => {
  let edgeToNodes: any = {};
  edges.map((edge: any) => {
    const n = getTargetNodes(edge, nodes);
    if (n.length) {
      edgeToNodes[edge.data.text] = n.map((node: any) => node.data.label)
    } else {
      edgeToNodes[edge.data.text] = n
    }

  })
  return edgeToNodes;
}

//获取单元操作列表
export const getNodeList = (nodes: any, edges: any, globle_physical_method: any) => {
  const list: any = [];//单元操作列表
  let UnitType: any = {};//单元操作类型
  let methods: any = {};//单元操作物性方法
  let block_parameter: any = {};//单元操作参数
  nodes.map((node: any) => {
    if (node.data.details.type === 'node') {
      let nodeInfo: any = {};
      const { data } = node;
      list.push(data.label)
      UnitType[data.label] = data.details.code;
      methods[data.label] = data.physical_method === globle_physical_method ? 'None' : data.physical_method ? data.physical_method : 'None';
      data.details.params.map((param: any) => {
        nodeInfo[param.field] = param.value
      })
      const from_list = getInEdges(node.id, edges).map((e: any) => e.data.text);
      const to_list = getOutEdges(node.id, edges).map((e: any) => e.data.text);
      let from_spec: any = []
      let to_spec: any = data.details.streamParams.find((r: any) => r.field === 'to_spec').value
      const cal_prmt: any = {};
      if (data.details.code === 'Mixer' || data.details.code === 'Spilt') {
        to_spec = new Array(to_list.length).fill(data.details.streamParams.find((r: any) => r.field === 'to_spec').value);
      }
      if (data.details.code === 'Distl') {
        to_spec = ["D", "B"]
      }
      from_spec = new Array(from_list.length).fill(data.details.streamParams.find((r: any) => r.field === 'from_spec').value);
      data.details.cal_prmt.map((param: any) => {
        cal_prmt[param.field] = param.value;
      })
      nodeInfo = {
        ...nodeInfo,
        from_list,
        from_spec,
        to_list,
        to_spec,
        cal_prmt
      }

      block_parameter[data.label] = nodeInfo;

    }
  })
  return { list, UnitType, methods, block_parameter };
}

//获取流股列表
export const getEdgeList = (edges: any) => {
  const list: any = []//流股列表
  let stream_input: any = {};//流股输入参数
  edges.map((edge: any) => {
    const { data } = edge;
    const { params, materials_list } = data;

    list.push(edge.data.text);
    let info: any = {
      parameter: {}
    };
    let z: any = "None";
    if (!materials_list.values.every((v: any) => v === null)) {
      z = materials_list.values
    }
    params.map((param: any) => {
      if (param.field === 'mode' || param.field === 'phase') {
        info[param.field] = param.value
      } else {
        info['parameter'][param.field] = param.value === null ? 'None' : param.value
      }
    })

    stream_input[edge.data.text] = {
      ...info,
      parameter: {
        ...info.parameter,
        z
      }
    }

  })
  return {
    list,
    stream_input
  };
}

//判断是否在0-1之间
export const is0_1 = (str: any) => {
  const pattern = /^(0(\.\d+)?|1(\.0*)?)$/;
  return pattern.test(str);
}

/**
 * elementsLibs 元素生成器
 * 创建元素库装饰器，允许链式添加多种属性
 * @param {Array} elements - 原始元素库
 * @returns {Object} 装饰器对象，包含add和build方法
 */
export function createElementsLibsDecorator(elements) {
  let decoratedElements = [...elements];
  const decorators = [];

  return {
    /**
     * 添加属性装饰器
     * @param {Function} propertyGenerator - 生成属性的函数
     * @returns {Object} 装饰器对象，支持链式调用
     */
    add(propertyGenerator) {
      decorators.push(propertyGenerator);
      return this;
    },

    /**
     * 执行所有装饰器并构建最终元素库
     * @returns {Array} 增强后的元素库
     */
    build() {
      decoratedElements = decoratedElements.map(category => ({
        ...category,
        children: category.children.map(element => {
          let enhancedElement = { ...element };

          // 依次应用所有装饰器
          decorators.forEach(decorator => {
            enhancedElement = decorator(enhancedElement);
          });

          return enhancedElement;
        })
      }));

      return decoratedElements;
    }
  };
}

export const dataURLtoBlob = (dataURL: any) => {
  const parts = dataURL.split(",");
  const contentType = parts[0].split(":")[1].split(";")[0];
  const byteString = atob(parts[1]);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const int8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i++) {
    int8Array[i] = byteString.charCodeAt(i);
  }
  return new Blob([int8Array], { type: contentType });
};

import {
  uploadFile,
  updateFlow,
} from "@/services/common";
import html2canvas from "html2canvas";
import userInfo from "@/Components/user";
import { message } from "antd";

// 提取封面
export const updateFlowthum_Pic = (data: any, showMessage: boolean) => {
  const div: any = document.getElementById("editor");
  html2canvas(div, {
    backgroundColor: "transparent",
  }).then(async (canvas: any) => {
    // const link = document.createElement('a');
    // link.href = canvas.toDataURL('image/png');
    // canvas.fill = 'blue';

    try {
      const blob = dataURLtoBlob(canvas.toDataURL("image/png"));
      const formData = new FormData();
      formData.append(
        "file",
        blob,
        `${data.project_id}_${data.id}_${randomId()}.png`
      );
      const res = await uploadFile(formData, userInfo.access_token);
      const s = await res.json();
      updateFlow(
        data.project_id,
        data.id,
        {
          // ...data,
          thumbnail_url: s.fileUrl,
        },
        userInfo.access_token
      ).then((r) => {
        if (r.status === 200) {
          if (showMessage) {
            message.success("流程已保存！");
          }
        } else {
          message.error("流程保存失败！");
        }
      });
    } catch (error) {
      console.error("上传出错：", error);
    }
  });
};